<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.ITEM">
  <ng-template [cxOutlet]="CartOutlets.ITEM_CONFIGURATOR_ISSUES"></ng-template>
  <ng-container *cxFeatureLevel="'4.2'">
    <cx-cart-item-validation-warning
      [code]="$any(item).product?.code"
    ></cx-cart-item-validation-warning>
  </ng-container>
  <div [ngClass]="compact ? 'cx-compact row' : 'row'">
    <!-- Item Image -->
    <div class="col-2 cx-image-container">
      <a
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        tabindex="0"
        >
        <cx-media
          [container]="item.product?.images?.['required']"
          format="cartIcon"
        ></cx-media>
      </a>
    </div>
    <!-- Item Information -->
    <div class="cx-info col-10">
      <div class="cx-info-container row">
        <!-- Item Description -->
        <div [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-5'">
          @if (item.product?.name) {
            <div class="cx-name">
              <a
                class="cx-link"
              [routerLink]="
                { cxRoute: 'product', params: item.product } | cxUrl
              "
                ><h3>{{ item.product?.name }}</h3></a
                >
              </div>
            }
            @if (item.product?.code) {
              <div class="cx-code">
                {{ 'cartItems.id' | cxTranslate }} {{ item.product?.code }}
              </div>
            }

            <!-- Item Details Outlet -->
            <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

            <!-- Variants -->
            @if (item.product?.baseOptions?.length) {
              @for (
                variant of $any(item).product?.baseOptions[0]?.selected
                ?.variantOptionQualifiers
                ; track
                variant) {
                <div
                  class="cx-property"
                  >
                  @if (variant.name && variant.value) {
                    <div class="cx-label">
                      {{ variant.name }}: {{ variant.value }}
                    </div>
                  }
                </div>
              }
            }
          </div>
          <!-- Item Price -->
          @if (item.basePrice) {
            <div
              class="cx-price"
              [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-2'"
              >
              <div
                class="cx-label"
                [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
                >
                {{ 'cartItems.itemPrice' | cxTranslate }}
              </div>
              @if (item.basePrice) {
                <div class="cx-value">
                  {{ item.basePrice.formattedValue }}
                </div>
              }
            </div>
          }
          <!-- Item Quantity -->
          <div class="cx-quantity" [ngClass]="compact ? '' : ' col-3'">
            <div
              class="cx-label"
              [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
              placement="left"
              title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
              >
              {{ 'cartItems.quantity' | cxTranslate }}
            </div>
            <div class="cx-value" [class.readonly-value]="readonly">
              <app-item-counter
                [control]="quantityControl"
                [readonly]="$any(item).updateable || readonly || options.isSaveForLater"
                [max]="$any(item).product?.stock?.stockLevel"
                [allowZero]="true"
                >
              </app-item-counter>
            </div>
          </div>
          <!-- Total -->
          @if (options.isSaveForLater) {
            <div
              class="cx-total"
              [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-2'"
              >
              <div
                class="cx-label"
              [ngClass]="
                compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'
              "
                >
                {{ 'saveForLaterItems.stock' | cxTranslate }}
              </div>
              @if ($any(item).product?.stock.stockLevel >= 0) {
                <div
                  class="cx-value"
                  >
                  {{ item.product?.stock?.stockLevel }}
                </div>
              } @else {
                <div class="cx-value">
                  {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
                </div>
              }
            </div>
          } @else {
            @if (item.totalPrice) {
              <div
                class="cx-total"
                [ngClass]="compact ? '' : ' col-md-3 col-xl-2'"
                >
                <div
                  class="cx-label"
                  [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
                  >
                  {{ 'cartItems.total' | cxTranslate }}
                </div>
                <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
              </div>
            }
          }
        </div>
        <!-- Availability -->
        @if (isProductOutOfStock(item.product)) {
          <div
            class="cx-availability col-12"
            >
            {{ 'addToCart.outOfStock' | cxTranslate }}
          </div>
        }

        <!-- Item Bundle Details Outlet -->
        <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"> </ng-template>

        <!-- Promotion -->

        <cx-promotions [promotions]="$any(item.promotions)"></cx-promotions>

        <!-- Actions -->
        @if ((!readonly || options.isSaveForLater) && item.updateable) {
          <div
            class="cx-actions col-12"
            >
            @if (!isProductOutOfStock(item.product)) {
              <ng-container
            *ngTemplateOutlet="
              options.optionalBtn;
              context: {
                $implicit: { loading: quantityControl.disabled, item: item }
              }
            "
            ></ng-container>
          }
          <div class="col-md-3 cx-remove-btn">
            <button
              (click)="removeItem()"
              [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
              [disabled]="quantityControl.disabled"
              attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
              class="link cx-action-link"
              >
              {{ 'common.remove' | cxTranslate }}
            </button>
          </div>
        </div>
      }
    </div>
  </div>

</ng-template>
